import React, { useState } from "react";
import { collection, addDoc, serverTimestamp, getDocs, query, where } from "firebase/firestore";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';
import { db } from "../firebaseConfig";
import "../css/App.css";
import { Link } from "react-router-dom";

export default function SubscribePage() {
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
    });
    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const trimmedEmail = form.email.trim();
        if (!trimmedEmail) {
            setStatus("Please enter a valid email.");
            return;
        }

        setStatus("Checking subscription...");
        try {
            const subsRef = collection(db, "subscribers");
            const q = query(subsRef, where("email", "==", trimmedEmail));
            const existingSnapshot = await getDocs(q);

            if (!existingSnapshot.empty) {
                setStatus("You're already subscribed with that email.");
                return;
            }

            await addDoc(subsRef, {
                firstName: form.firstName.trim(),
                lastName: form.lastName.trim(),
                email: trimmedEmail,
                phone: form.phone.trim(),
                createdAt: serverTimestamp(),
            });

            setStatus("Thank you for subscribing!");
            setForm({ firstName: "", lastName: "", email: "", phone: "" });
        } catch (err) {
            console.error("Firestore error", err);
            setStatus("Failed to save. Please try again.");
        }
    };

    return (
        <div>
            <Helmet>
                <title>Subscribe</title>
                <meta name="description" content="Help form Catholic evangelists with a one-time or recurring gift." />

                {/* Open Graph */}
                <meta property="og:title" content="Subscribe to SOLE" />
                <meta property="og:description" content="Subscribe to our mailing list to stay up to date with SOLE." />
                <meta property="og:image" content="https://i.imgur.com/SCD4yW4.png" />
                <meta property="og:url" content="https://soleministries.org/subscribe" />
                <meta property="og:type" content="website" />

                {/* Twitter preview */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Subscribe to SOLE" />
                <meta name="twitter:description" content="Subscribe to our mailing list to stay up to date with SOLE." />
                <meta name="twitter:image" content="https://i.imgur.com/SCD4yW4.png" />
                <link href="//cdn-images.mailchimp.com/embedcode/classic-061523.css" rel="stylesheet" type="text/css" />
            </Helmet>
            <Navbar />
            <main className="subscribe-page">
                <div className="subscribe-hero">
                    <h1>Join the SOLE Email List</h1>
                    <p>Stay up to date on meetings, events, and resources for apologetics, catechesis, and evangelization.</p>

                    <form onSubmit={handleSubmit} className="subscribe-form">
                        <input
                            type="text"
                            name="firstName"
                            placeholder="First Name"
                            value={form.firstName}
                            onChange={handleChange}
                            className="subscribe-input"
                            required
                        />
                        <input
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            value={form.lastName}
                            onChange={handleChange}
                            className="subscribe-input"
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            placeholder="Email Address"
                            value={form.email}
                            onChange={handleChange}
                            className="subscribe-input"
                            required
                        />
                        <input
                            type="tel"
                            name="phone"
                            placeholder="Phone Number"
                            value={form.phone}
                            onChange={handleChange}
                            className="subscribe-input"
                        />

                        <button type="submit" className="subscribe-button">
                            Subscribe
                        </button>
                    </form>

                    <div style={{ textAlign: "center", margin: "1.5rem 0" }}>
                        <span style={{ fontSize: "0.95rem", color: "#4a4a4a", marginRight: "0.5rem" }}>
                            Have a question?
                        </span>
                        <Link to="/contact" style={{ fontSize: "0.95rem", fontWeight: 600 }}>
                            Contact us.
                        </Link>
                    </div>
                    {status && <p className="subscribe-status">{status}</p>}
                </div>
            </main>
            <Footer />
        </div>
    );
}
